import { ChangeDetectionStrategy, Component, Input, OnInit } from "@angular/core";
import { KYC_SUCCESS_SCREEN_VIEWED } from "@helpers/constants";
import { SegmentService } from "@main-services/segment.service";
import { NewProfileFacade } from "@modules/main/components/profile/new-profile/state/new-profile.facade";
import { RudderstackService } from "@main-services/rudderstack.service";

@Component({
	selector: "kyc-success",
	templateUrl: "./kyc-success.component.html",
	styleUrls: ["./kyc-success.component.scss"],
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false
})
export class KycSuccessComponent implements OnInit {
	@Input() isInfoEdited: boolean;
	@Input() forceKycFlow: boolean;

	public profile$ = this.profileFacade.getProfile$();

	public constructor(
		private profileFacade: NewProfileFacade,
		private readonly segmentService: SegmentService,
		private readonly rudderstackService: RudderstackService
	) {}

	public ngOnInit(): void {
		this.segmentService.track({ name: KYC_SUCCESS_SCREEN_VIEWED });
		this.rudderstackService.track({ name: KYC_SUCCESS_SCREEN_VIEWED });
	}
}
